import React from 'react';

const NoAccessPage = ({ errorMessage }) => {
    return (
        <div>
            {errorMessage === 'user_access_denied' ? (
                <div style={{ padding: '20px', textAlign: 'left' }}>
                    <p>You have successfully authenticated but you do not have access to this application. Please contact your system administrator.</p>
                </div>
            ) : (
                <p>You do not have access to this page.</p>
            )}
        </div>
    );
};

export default NoAccessPage;
